Hop.defineModule('barometer-nav', (domRoot) => {
    const $container = $(domRoot);
    const $navContainer = $container.find('.barometer-nav');
    const $barometerToggle = $container.find('.js-toggle');
    const $barometerMainList = $container.find('.js-main-list');
    const $openListCtrl = $container.find('[data-list-toggle]');
    const $closeListCtrl = $container.find('[data-list-close]');

    const HEADER_HEIGHT = document.querySelector('.hopheader').offsetHeight;
    const BAROMETER_NAV_OFFSET_TOP = HEADER_HEIGHT + $container.outerHeight();
    const MOBILE_NAV_BEHAVIOUR = window.matchMedia('(max-width: 767px)').matches;

    function adjustListPositions() {
        $barometerMainList.find('ul').each((idx, el) => {
            // As this page is max-width: 1920px, if you have a screen size > to 1920, the barometer nav won't be sticked to left side
            // Then, the issue is that .offset() property adds the gap between left border of your window, and actual DOM element
            // To fix this, we should completely refacto this part.....first...and test if we can do this with plain css
            // But not enough time now, so the idea is just to calculate the gap between left window border  and content, then remove it from the calc
            // https://jira.malt.com/browse/SN3-4940
            const navOffset = $container.offset().left;

            const $el = $(el);
            const parentOffset = $el.closest('li').offset();

            $el.css({
                height: `${$barometerMainList.height()}px`,
                top: `${BAROMETER_NAV_OFFSET_TOP}px`,
                left: `${parentOffset.left + $el.closest('li').innerWidth() - navOffset}px`,
            });
        });
    }

    function openList(list) {
        list.addClass('opened');
    }

    function closeList(list) {
        list.removeClass('opened');
    }

    function adjustListPositionForMobile() {
        $navContainer.css({
            width: '100%',
            height: $(window).height(),
        });
    }

    function toggleNav(e) {
        e.preventDefault();
        MOBILE_NAV_BEHAVIOUR && $navContainer.css({top: `${HEADER_HEIGHT}px`});
        $container.toggleClass('opened');
        $('html').toggleClass('BAROMETER_NAV_OPENED');
    }

    function closeNav() {
        $container.removeClass('opened');
        $('html').removeClass('BAROMETER_NAV_OPENED');
    }

    $barometerToggle.click(toggleNav);

    if (MOBILE_NAV_BEHAVIOUR) {
        adjustListPositionForMobile();
        $openListCtrl.on('click', (e) => {
            e.preventDefault();
            const listToOpen = $(`[data-id="${$(e.target).attr('data-list-toggle')}"]`);
            openList(listToOpen);
        });

        $closeListCtrl.on('click', (e) => {
            const listToClose = $(`[data-id="${$(e.target).attr('data-list-close')}"]`);
            closeList(listToClose);
        });
    } else {
        adjustListPositions();
        $('body').on('click', (e) => {
            if (!e.target.closest('.barometer-nav__wrapper')) {
                closeNav();
            }
        });

        $(window).on('resize', adjustListPositions);
    }

    return function destroy() {
        $(window).off('resize', adjustListPositions);
    };
});
